import { defineStore } from 'pinia'

export const useSettingsStore = defineStore('localSettings', {
  state: () => ({
    theme: 'light',
    language: 'de',
    genericInstancesEnabled: false,
    loadBarnImages: false,
    showVersions: false,
    showTypeInformation: false,
    autoAddServiceProviders: true,
    enableAutoLogin: true,
    serviceProvidersExcludedFromAutoAdd: [],
    showCameraIdsOnGridView: false,
    languageSelected: false,
    forcedConnectionStrategy: null,
    forceConnectionStrategy: false,
    enableDeveloperSettings: false,
    instanceListDisplayMode: 'grid',
    useAlignmentHelperAsImageReplacement: false,
    showFrameAnnotationTour: true,
    userMode: undefined, // basic or advanced
  }),
  persist: true,
  share: {
    enable: true,
    initialize: false,
  },
  getters: {
    isUserModeSet: state => state.userMode !== undefined,
    isBasicUserMode: state => state.userMode === 'basic',
    isAdvancedUserMode: state => state.userMode === 'advanced',
  },
  actions: {
    setShowFrameAnnotationTour(value) {
      this.showFrameAnnotationTour = value
    },
    setTheme(theme) {
      this.theme = theme
      document.querySelector('meta[name="theme-color"]').setAttribute('content', '#212121');
    },
    setLanguage(language) {
      this.languageSelected = true
      this.language = language
    },
    setForcedConnectionStrategy(strategy) {
      this.forcedConnectionStrategy = strategy
    },
    setUserMode(mode) {
      this.userMode = mode
    },
    toggleUserMode() {
      if(!this.isUserModeSet) {
        this.userMode = 'advanced'
        return
      }
      this.userMode = this.userMode === 'basic' ? 'advanced' : 'basic'
    },
  },
})
